module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.realValue),
      expression: "realValue"
    }],
    class: _vm.classObject,
    attrs: {
      "type": "range",
      "min": _vm.min,
      "max": _vm.max,
      "step": _vm.step,
      "name": _vm.name,
      "orient": _vm.vertical && 'vertical',
      "disabled": _vm.disabled,
      "number": ""
    },
    domProps: {
      "value": (_vm.realValue)
    },
    on: {
      "__r": function($event) {
        _vm.realValue = $event.target.value
      }
    }
  })
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-e1158f56"}!./~/vue-loader/lib/selector.js?type=template&index=0!./~/vue-bulma-slider/src/Slider.vue
// module id = 473
// module chunks = 40